import { AxiosStatic } from "axios";

interface IGlobal {
    axios: AxiosStatic | null;
}

const Global: IGlobal = {
    axios: null,
};

export default Global;
